export const createPollMutation = /* GraphQL */ `
  mutation CreatePoll($input: CreatePollInput!, $condition: ModelPollConditionInput) {
    createPoll(input: $input, condition: $condition) {
      description
      createdAt
      expires
      firstImage
      firstLikieeId
      id
      isActive
      secondImage
      secondLikieeId
      title
      updatedAt
      owner
      votes {
        id
        owner
        vote
        pollId
      }
    }
  }
`;

export const updatePollMutation = /* GraphQL */ `
  mutation UpdatePollMutation($input: UpdatePollInput!, $condition: ModelPollConditionInput) {
    updatePoll(input: $input, condition: $condition) {
      id
      isActive
    }
  }
`;

export const createPollVoteMutation = /* GraphQL */ `
  mutation CreatePollVote($input: CreatePollVoteInput!, $condition: ModelPollVoteConditionInput) {
    createPollVote(input: $input, condition: $condition) {
      vote
      poll {
        votes {
          id
          owner
          vote
          pollId
        }
      }
    }
  }
`;
